<template>
    <div>
        <base-box
            v-bind="$props"
            v-on="$listeners"
            border-radius="large"
            background-color="grey"
            class="file-upload-card"
        >
            <template slot="content">
                <g-media-object>
                    <template slot="right">
                        <g-upload
                            :action="uploadUrl"
                            :headers="uploadHeaders"
                            :multiple="true"
                            :showUploadList="false"
                            @change="handleUpload"
                        >
                            <g-button 
                                shape="circle" 
                                icon="upload" 
                                theme="live"
                                :loading="isFileUploading" 
                            />
                        </g-upload>
                    </template>
                    <template>
                        <div class="margin-bottom-small">
                            <g-typography tag="h4" font-weight="semibold" value="Other Uploads"/>
                        </div>
                        <div class="margin-bottom-small">
                            <g-typography value="Upload any documents you want to share with the brand here"/>
                        </div>
                        <div v-for="file in files" class="margin-bottom-small loaded-file">
                            <g-media-object>
                                <template slot="left">
                                    <g-icon name="check-circle" type="solid"/>
                                </template>
                                <template slot="default">
                                    <g-typography tag="div" text-overflow="ellipsis" :value="file.label" class="proposal-file-label"/>
                                </template>
                                <template slot="right">
                                    <g-button :minimalist="true" @click="attemptDelete(file.id)">Remove</g-button>
                                </template>
                            </g-media-object>
                        </div>
                    </template>
                </g-media-object>
            </template>
        </base-box>
        <file-delete-modal
            :visible="deleteModal"
            @modal-delete="confirmDelete"
            @modal-cancel="closeModal"
        />
    </div>
</template>

<script>
    import FileDeleteModal from "./FileDeleteModal";

    export default {
        name: "ProposalFilesCard",

        components: {
            FileDeleteModal,
        },

        props: {
            uploadUrl: {
                type: String,
                required: true,
            },

            uploadHeaders: {
                type: Object,
                required: true,
            },

            files: {
                type: Array,
                default() {
                    return []
                },
            },

            isFileUploading: {
                type: Boolean
            },
        },

        data() {
            return {
                deleteModal: false,
                fileToDelete: null,
            };
        },

        methods: {
            attemptDelete(fileId) {
                this.fileToDelete = fileId;
                this.deleteModal = true;
            },

            confirmDelete() {
                this.$emit('handle-file-delete', {file: this.fileToDelete});
                this.closeModal();
            },

            closeModal() {
                this.fileToDelete = null;
                this.deleteModal = false;
            },

            handleUpload(info) {
                this.$emit('handle-file-upload', info);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .file-upload-card {
        & .margin-bottom-small {
            margin-bottom: $g-spacing-3;
        }
        & .loaded-file {
            & .g-icon {
                color: $g-color-green-5;
            }
            & ::v-deep .ant-btn {
                height: auto;
            }
            & .proposal-file-label {
                max-width: 235px;
            }
        }
    }
</style>